<div class="info">
  <div class="container">
    <div class="row mx-0">
      <div class="tags">
        <div class="tag grey noHover">Threat Profile</div>
      </div>
      <h1>{{ profile?.profile_name }}</h1>
      <i
        *ngIf="favorited"
        class="k-icon k-font-icon k-i-bookmark favorite k-color-primary"
        (click)="onRemoveFavorite()"
      ></i>
      <i
        *ngIf="!favorited"
        class="k-icon k-font-icon k-i-bookmark-outline favorite k-color-primary"
        (click)="onAddFavorite()"
      >
      </i>
      <div class="options">
        <button
          themeColor="primary"
          icon="comment"
          (click)="onFeedback()"
          kendoButton
        >
          Feedback
        </button>
      </div>
    </div>
  </div>
</div>
<main>
  <ng-template #notShow>
    <p>--</p>
  </ng-template>
  <div class="container">
    <div class="row">
      <aside class="col-lg-2 px-0">
        <ul>
          <li><a (click)="scrollTo('overview')">Overview</a></li>
          <li><a (click)="scrollTo('description')">Description</a></li>
          <li>
            <ul class="sub">
              <li *ngIf="profile?.overview && profile?.overview.length > 0">
                Overview
              </li>
              <li *ngIf="profile?.targeting && profile?.targeting.length > 0">
                Targeting
              </li>
              <li *ngIf="profile?.delivery && profile?.delivery.length > 0">
                Delivery
              </li>
              <li
                *ngIf="
                  profile?.installation && profile?.installation.length > 0
                "
              >
                Installation
              </li>
              <li
                *ngIf="profile?.persistence && profile?.persistence.length > 0"
              >
                Persistence
              </li>
              <li *ngIf="profile?.modules && profile?.modules.length > 0">
                Modules
              </li>
              <li
                *ngIf="
                  profile?.communication && profile?.communication.length > 0
                "
              >
                Communication
              </li>
            </ul>
          </li>
          <li>
            <a
              *ngIf="titanRelatedReports?.reportCount > 0"
              (click)="scrollTo('titan-reports')"
              >Titan Reports</a
            >
          </li>
          <li><a (click)="scrollTo('tagging')">Tagging</a></li>
          <li *ngIf="relatedHuntPackages?.length > 0">
            <a (click)="scrollTo('relatedHuntPackages')"
              >Related Hunt Packages</a
            >
          </li>
          <li
            *ngIf="
              mitres.length > 0 || profile?.mapping.mitre.mitre_software_id
            "
          >
            <a (click)="scrollTo('mitre')">MITRE Information</a>
          </li>
        </ul>
      </aside>
      <div class="col-12 col-lg-10 px-0">
        <cyborg-section id="overview">
          <cyborg-section-title>
            <div class="logo">
              <span>Overview</span>
            </div>
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-6 col-lg-4">
                  <span>Also Known As</span>
                  <p *ngIf="profile?.also_known_as.length > 0; else notShow">
                    {{ profile?.also_known_as.join(', ') }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Impact</span>
                  <p *ngIf="profile?.impact.length > 0; else notShow">
                    {{ profile?.impact }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Motivations</span>
                  <p
                    *ngIf="
                      profile?.context?.motivations.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context?.motivations.join(', ') }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Threat Categories</span>
                  <p
                    *ngIf="
                      profile?.context.threat_categories.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context?.threat_categories.join(', ') }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Threat Types</span>
                  <p
                    *ngIf="
                      profile?.context.threat_types.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context.threat_types.join(', ') }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Attack Surfaces</span>
                  <p
                    *ngIf="
                      profile?.context.attack_surfaces.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context.attack_surfaces }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Source Regions</span>
                  <p
                    *ngIf="
                      profile?.context.source_regions.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context.source_regions }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Source Countries</span>
                  <p
                    *ngIf="
                      profile?.context.source_countries.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context.source_countries }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Target Regions</span>
                  <p
                    *ngIf="
                      profile?.context.target_regions.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context.target_regions.join(', ') }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Target Countries</span>
                  <p
                    *ngIf="
                      profile?.context.target_countries.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context.target_countries.join(', ') }}
                  </p>
                </div>
                <div class="col-6 col-lg-4">
                  <span>Target OSes</span>
                  <p
                    *ngIf="
                      profile?.context.target_oses.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context.target_oses.join(', ') }}
                  </p>
                </div>
                <div class="col-12">
                  <span>Target Industries</span>
                  <p
                    *ngIf="
                      profile?.context.target_industries.length > 0;
                      else notShow
                    "
                  >
                    {{ profile?.context?.target_industries.join(', ') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
        <cyborg-section id="description">
          <cyborg-section-title>
            <div class="logo">
              <span>Description</span>
            </div>
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-12" *ngIf="profile?.overview">
                  <span>Overview</span>
                  <cyborg-markdown [md]="profile?.overview"></cyborg-markdown>
                </div>
                <div class="col-12" *ngIf="profile?.targeting">
                  <span>Targeting</span>
                  <cyborg-markdown [md]="profile?.targeting"></cyborg-markdown>
                </div>

                <div class="col-12" *ngIf="profile?.delivery">
                  <span>Delivery</span>
                  <cyborg-markdown [md]="profile?.delivery"></cyborg-markdown>
                </div>
                <div class="col-12" *ngIf="profile?.installation">
                  <span>Installation</span>
                  <cyborg-markdown
                    [md]="profile?.installation"
                  ></cyborg-markdown>
                </div>
                <div class="col-12" *ngIf="profile?.persistence">
                  <span>Persistence</span>
                  <cyborg-markdown
                    [md]="profile?.persistence"
                  ></cyborg-markdown>
                </div>

                <div class="col-12" *ngIf="profile?.modules">
                  <span>Modules</span>
                  <cyborg-markdown [md]="profile?.modules"></cyborg-markdown>
                </div>

                <div class="col-12" *ngIf="profile?.communication">
                  <span>Communication</span>
                  <cyborg-markdown
                    [md]="profile?.communication"
                  ></cyborg-markdown>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
        <cyborg-section
          *ngIf="titanRelatedReports?.reportCount > 0"
          id="titan-reports"
        >
          <cyborg-section-title>
            <div class="logo">
              <img src="/assets/img/icons/intel-icon-small.png" />
              <span>Titan Reports</span>
            </div>
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-12">
                  <p *ngIf="true" class="titan-info">
                    <i class="k-icon k-font-icon k-i-info"></i>
                    <ng-container
                      *ngIf="titanRelatedReports.reports.length == 0"
                      >Titan reports are only visible to Premium
                      users.</ng-container
                    >
                    Must have a Titan account to access reports.
                  </p>
                  <div class="reportContainer" *ngIf="titanRelatedReports">
                    <div
                      *ngIf="
                        titanRelatedReports.reports.length > 0;
                        else showSkeleton
                      "
                    >
                      <div
                        class="report"
                        *ngFor="let report of titanRelatedReports.reports"
                      >
                        <a
                          class="link"
                          href="{{ report.portalReportUrl }}"
                          target="_blank"
                        >
                          {{ report.subject }}</a
                        >
                        {{ report.released | date : 'longDate' }}
                      </div>
                    </div>
                    <ng-template #showSkeleton>
                      <div *ngFor="let lorem of loremTexts">
                        <p class="sensitive-text">{{ lorem }}</p>
                      </div>
                    </ng-template>
                    <span class="titan-tag">
                      All reports are available in the
                      <a
                        style="display: inline"
                        class="link"
                        href="https://titan.intel471.com"
                        target="_blank"
                      >
                        Titan
                      </a>
                      platform
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
        <cyborg-section id="tagging">
          <cyborg-section-title>
            <div class="logo">
              <span>Tagging</span>
            </div>
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-12" *ngIf="profile?.tags">
                  <cyborg-facet-buttons
                    class="tile-facets"
                    [facets]="tags"
                    [groupByCategory]="false"
                  ></cyborg-facet-buttons>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
        <cyborg-section
          *ngIf="relatedHuntPackages?.length > 0"
          id="relatedHuntPackages"
        >
          <cyborg-section-title>
            <div class="logo">
              <span>Related Hunt Packages</span>
            </div>
          </cyborg-section-title>
          <div *ngIf="relatedHuntPackages">
            <hunt-package
              class="col-12"
              *ngFor="let huntPackage of relatedHuntPackages"
              [data]="huntPackage"
            >
            </hunt-package>
          </div>
        </cyborg-section>

        <cyborg-section
          *ngIf="mitres.length > 0 || profile?.mapping.mitre.mitre_software_id"
          id="mitre"
        >
          <cyborg-section-title>
            <div class="logo">
              <span>MITRE Information</span>
            </div>
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-12 col-lg-6">
                  <span>MITRE Group ID</span>
                  <p>
                    <a
                      *ngIf="
                        profile?.mapping.mitre.mitre_software_id;
                        else notShow
                      "
                      href="https://attack.mitre.org/software/{{
                        profile?.mapping.mitre.mitre_software_id
                      }}"
                      target="_blank"
                      >{{ profile?.mapping.mitre.mitre_software_id }}</a
                    >
                  </p>
                </div>
                <div class="col-12 col-lg-6">
                  <table class="mitre-table">
                    <thead>
                      <tr>
                        <th>Mitre Attack Technique</th>
                        <th>Id</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="mitres.length == 0">
                        <td>--</td>
                        <td>--</td>
                      </tr>
                      <tr *ngFor="let mitre of mitres">
                        <td>{{ mitre.technique }}</td>
                        <td>
                          <a
                            href="https://attack.mitre.org/techniques/{{
                              mitre.id.replace('.', '/')
                            }}"
                            target="_blank"
                            >{{ mitre.id }}</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
      </div>
    </div>
  </div>
</main>
